import { useEffect, useRef, useState } from 'react';
import { useWeb3 } from '@/hooks/use-web3';
import { CreateUnstakinguser, isCompleteModalType, PoolListType } from '@/types';
import { Button } from '@mui/material';
import Loading from '../mui/Backdrop';
import {
  CALCULATEPENDINGREWARDFORALLSTAKES,
  CLAIMALLREWARD,
  RES_OVER_BLOCK,
  RES_SUCCESS,
  STAKING_USER_STATE,
  WITHDRAWALLPRINCIPAL,
} from '@/lib/common/name-space';
import { checkTokenWithdarw, stateWithdraw, tokenPrice } from '@/api/staking/read';
import { decryptPassword } from '@/lib/Cryptos';
import { CheckTokenType, RewardListType } from '@/types/staking/read';
import { toast } from 'react-toastify';
import { claimAllRewardUsers, unstakingUsers } from '@/api/staking/create';
import { useNavigate } from 'react-router-dom';
import { addLocalSetStorageArr } from '@/lib/storage';
import ResultPopup from '@/lib/ResultPopup';
import { STATE_STAKE } from '@/lib/common/name-space/status';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function WithdrawAll({ detail }: { detail: PoolListType }) {
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState('');
  const { web3authCall, address: addr } = useWeb3();
  const { isConnected } = useWeb3AuthConnect();
  const navigate = useNavigate();
  const [isCompleteModal, setIsCompleteModal] = useState<isCompleteModalType>({
    success: false,
    fail: false,
    pending: false,
  });
  const [errorMsg, setErrorMsg] = useState('');
  // isWithdrawBtn 초기 값 false로 설정하면 버튼이 보인 후 서버값으로 바뀌기 때문에 화면에 버튼이 보였다가 사라짐
  const [rewardAmt, setRewardAmt] = useState('0');
  const [isRetry, setIsRetry] = useState(false); // 50블록 넘었을 때 다시 시도

  useEffect(() => {
    if (isConnected && address) {
      return;
    }
    (async () => {
      setAddress(addr);
      const obj: RewardListType = {
        poolId: detail.poolId,
        address: addr,
      };
      const re = await stateWithdraw(obj);
      console.log(`re`);
      console.log(re);
      if (re.status !== 200) {
        return;
      }
      // 마지막으로 리워드가 있는지 확인 후 있으면? 리워드
      await checkReward(addr);
      // db 데이터가 잘 못 되었을 때 마지막으로 전체 리워드 수령을 해버린다.
    })();

    return () => {};
  }, [web3authCall, isConnected, addr]);

  // 50블록 안에 채택이 되지 않을 시 다시 시도할 때
  useEffect(() => {
    if (isRetry) {
      (async () => {
        await handleWithdrawAll();
        setIsRetry(false);
      })();
    }

    return () => {};
  }, [isRetry]);

  const checkReward = async (address: string) => {
    const latestReward = await web3authCall?.callStaking(CALCULATEPENDINGREWARDFORALLSTAKES, detail.contractAddr, [
      address,
    ]);
    console.log(`checkReward`);
    console.log(latestReward);
    setRewardAmt(latestReward);
  };
  const handleWithdrawAll = async () => {
    if (!web3authCall?.connected() && !detail.contractAddr) {
      return;
    }
    setIsLoading(true);

    // // 회수 전 남은 리워드가 있는 경우 모든 리워드를 회수한다.
    // if (rewardAmt !== '0') {
    //   console.log(`rewardAmt`);
    //   console.log(rewardAmt);
    //   let rewardContract = null;
    //   try {
    //     rewardContract = await web3authCall?.callStaking(CLAIMALLREWARD, detail.contractAddr, [address]);
    //     if (rewardContract.code !== 200) {
    //       setIsLoading(false);
    //       return;
    //     }
    //   } catch (e) {
    //     setIsLoading(false);
    //     return;
    //   }
    //   // 서버에 전송
    //   const obj = {
    //     poolId: detail.poolId,
    //     address: address,
    //     rewardAmt: rewardContract.data.contractAmount,
    //     rewardHash: rewardContract.data.transactionHash,
    //     rewardCnt: 0,
    //   };
    //   console.log('CLAIMALLREWARD');
    //   console.log(JSON.stringify(obj));
    //   try {
    //     await claimAllRewardUsers(obj, false);
    //   } catch (e) {
    //     setIsLoading(false);
    //     addLocalSetStorageArr('rewardAll', obj);
    //   }
    // }

    let hash = null;
    let ticker = null;
    let action: any;

    try {
      const price = await tokenPrice();
      const decrypt = decryptPassword(price.data.value);
      const checkTokenType: CheckTokenType = {
        key: price.data.key,
        value: price.data.value,
        poolId: detail.poolId,
        stakeAmt: 'checkTokenWithdraw',
        address: address,
      };
      const check = await checkTokenWithdarw(checkTokenType);
      console.log(check);
      if (String(decrypt) !== String(check.data)) {
        toast.error('error');
        return;
      }
      ticker = check.data;

      // 실제 트랜젝션 처리
      action = await web3authCall?.callStaking(WITHDRAWALLPRINCIPAL, detail.contractAddr, [address]);

      if (action.code === RES_OVER_BLOCK) {
        triggerIsCompleteModal('pending');
        setErrorMsg(action.msg);
        return;
      } else if (action.code !== RES_SUCCESS) {
        triggerIsCompleteModal('fail');
        setErrorMsg(action.msg);
        return;
      }

      // 디비처리
      hash = action.data.transactionHash;
      console.log(action);
      const obj: CreateUnstakinguser = {
        poolId: detail.poolId,
        address: address,
        stakeAmt: action.data.contractWithdrawAmt,
        hash: hash,
        ticker: ticker,
        stakeState: STAKING_USER_STATE.WITHDRAW,
        stakeIndex: 0, // 전체를 수령하기 때문에 의미가 없음
        usdt: '0', // 서버에서 처리
      };
      // 언스테이킹과 회수 로직이 같아 동일하게 사용됨
      const re = await unstakingUsers(obj, false);
      console.log(`result`);
      console.log(re);
      triggerIsCompleteModal('success');
      setTimeout(() => {
        navigate('/portfolio');
      }, 5000);
    } catch (e: any) {
      console.error(e);
      triggerIsCompleteModal('fail');
      setErrorMsg(e?.message || JSON.stringify(e));

      // 트랜잭션 성공 후 DB 저장 실패 시 로컬 저장
      if (action?.data) {
        const obj: CreateUnstakinguser = {
          poolId: detail.poolId,
          address: address,
          stakeAmt: action.data.contractWithdrawAmt,
          hash: action.data.transactionHash,
          ticker: ticker,
          stakeState: STAKING_USER_STATE.WITHDRAW,
          stakeIndex: 0,
          usdt: '0',
        };
        addLocalSetStorageArr('withdraw', obj);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const triggerIsCompleteModal = (key: keyof isCompleteModalType) => {
    setIsCompleteModal((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // const handleClaimAll = async () => {
  //   await claimAllReward();
  // };
  // const claimAllReward = async () => {
  //   const re = await web3authCall!.callStaking(CLAIMALLREWARD, detail.contractAddr, [address]);
  //   return re;
  // };
  return (
    <>
      {/* <Button fullWidth variant="contained" onClick={handleClaimAll}>
        테스트 클래임 올
      </Button> */}
      <Button fullWidth variant="contained" onClick={handleWithdrawAll}>
        Withdraw
      </Button>

      <ResultPopup
        isCompleteModal={isCompleteModal}
        triggerIsCompleteModal={triggerIsCompleteModal}
        errorMsg={errorMsg}
        type={STATE_STAKE.WITHDRAW}
        setIsRetry={setIsRetry}
      />
      <Loading isLoading={isLoading} />
    </>
  );
}
